<template>
	<div class="quoted-message-wrapper">
		<!-- 引用卡片：统一使用卡片样式（单条和多条都使用面板） -->
		<div class="quoted-message-card" :class="{ 'single-message': isSingleMessage }" @click="handleClick">
			<span class="quote-icon quote-left">"</span>
			<div class="card-header">
				<span class="card-title">{{ isSingleMessage ? '引用' : '引用消息' }}</span>
			</div>
			<div class="card-preview">
				<div
					v-for="(msg, idx) in previewMessages"
					:key="idx"
					class="preview-line">
					<span class="sender-name">{{ getSenderName(msg) }}:</span>
					<span class="content-preview">{{ getMessageText(msg) }}</span>
				</div>
			</div>
			<div class="card-footer" v-if="!isSingleMessage">
				<span class="message-count">共{{ messages.length }}条消息</span>
			</div>
			<span class="quote-icon quote-right">"</span>
			<div v-if="showClose" class="close-btn" @click.stop="clearAll">
				<i class="el-icon-close"></i>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'QuotedMessage',
	props: {
		messages: {
			type: Array,
			default: () => []
		},
		showClose: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		previewMessages() {
			// 最多显示3条消息预览
			return this.messages.slice(0, 3);
		},
		// 🔥 判断是否为单条消息引用
		isSingleMessage() {
			return this.messages.length === 1;
		}
	},
	methods: {
		getSenderName(msg) {
			// 🔥 优先显示用户昵称，不做"我"的特殊处理
			if (msg.sendNickName) return msg.sendNickName;
			if (msg.senderName) return msg.senderName;
			if (msg.showName) return msg.showName;
			return '未知用户';
		},
		getMessageText(msg) {
			if (!msg.content) return '[空消息]';

			// 兼容发送时的引用数据格式（type 是数字）和接收时的格式
			const msgType = msg.type;

			if (msgType === 0 || msgType === this.$enums?.MESSAGE_TYPE?.TEXT) {
				let content = msg.content;
				if (content.length > 30) {
					return content.substring(0, 30) + '...';
				}
				return content;
			} else if (msgType === 1 || msgType === this.$enums?.MESSAGE_TYPE?.IMAGE) {
				return '[图片]';
			} else if (msgType === 2 || msgType === this.$enums?.MESSAGE_TYPE?.FILE) {
				try {
					const fileData = typeof msg.content === 'string' ? JSON.parse(msg.content) : msg.content;
					return `[文件] ${fileData.name || '未知文件'}`;
				} catch (e) {
					return '[文件]';
				}
			} else if (msgType === 3 || msgType === this.$enums?.MESSAGE_TYPE?.AUDIO) {
				return '[语音]';
			}

			return '[消息]';
		},
		clearAll() {
			this.$emit('clear-all');
		},
		handleClick() {
			// 点击打开详情
			this.$emit('open-detail');
		}
	}
}
</script>

<style scoped lang="scss">
.quoted-message-wrapper {
	padding: 8px 0 4px 0;

	.quoted-message-card {
		position: relative;
		display: inline-block;
		min-width: 200px;
		max-width: 300px;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		padding: 12px;
		padding-left: 20px;
		padding-right: 32px;
		background: #f5f5f5;
		cursor: pointer;
		transition: all 0.2s ease;
		text-align: left;

		// 🔥 单条消息引用的紧凑样式
		&.single-message {
			min-width: 160px;
			padding: 10px;
			padding-left: 18px;
			padding-right: 28px;

			.card-header {
				margin-bottom: 6px;
				padding-bottom: 6px;
			}

			.card-preview .preview-line {
				font-size: 13px;
			}
		}

		.quote-icon {
			font-family: Georgia, serif;
			font-size: 28px;
			line-height: 1;
			color: rgba(0, 0, 0, 0.12);
			font-weight: bold;
			user-select: none;

			&.quote-left {
				position: absolute;
				left: 6px;
				top: 4px;
			}

			&.quote-right {
				position: absolute;
				right: 20px;
				bottom: 2px;
			}
		}

		.close-btn {
			position: absolute;
			right: 6px;
			top: 6px;
			width: 20px;
			height: 20px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			color: #909399;
			border-radius: 50%;
			transition: all 0.2s;
			z-index: 1;

			&:hover {
				color: #606266;
				background: rgba(0, 0, 0, 0.05);
			}

			i {
				font-size: 14px;
			}
		}

		&:hover {
			background: #ebebeb;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		}

		.card-header {
			display: flex;
			align-items: center;
			gap: 8px;
			margin-bottom: 10px;
			padding-bottom: 8px;
			border-bottom: 1px solid #ddd;
			margin-left: 4px;

			.card-title {
				flex: 1;
				font-weight: bold;
				font-size: 14px;
				color: #333;
			}
		}

		.card-preview {
			margin-bottom: 8px;

			.preview-line {
				font-size: 13px;
				color: #666;
				margin-bottom: 4px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				line-height: 1.5;

				.sender-name {
					font-weight: 500;
					color: #333;
					margin-right: 4px;
				}

				.content-preview {
					color: #666;
				}
			}
		}

		.card-footer {
			padding-top: 8px;
			border-top: 1px solid #ddd;

			.message-count {
				font-size: 12px;
				color: #999;
			}
		}
	}
}
</style>
